import NsButtonActionsGroup from "../../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../../components/buttons/NsButtonAction";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import React from "react";

export default function UtentiAssociatiView({
                                                utentiAssociati,
                                                translate,
                                                onClickEliminaUtentiAssociati,
                                            }) {

    return (
        <NsDataTable
            data={utentiAssociati}
            columns={[
                {
                    name: translate('Nome'),
                    selector: row => row.nome,
                    sortable: true,
                    filtroHeader: {
                        filterFunction: (item, filtro) => (item.nome && item.nome.toLowerCase().includes(filtro.toLowerCase()))
                    }
                },
                {
                    name: translate('Cognome'),
                    selector: row => row.cognome,
                    sortable: true,
                    filtroHeader: {
                        filterFunction: (item, filtro) => (item.cognome && item.cognome.toLowerCase().includes(filtro.toLowerCase()))
                    }
                },
                {
                    name: translate('E-mail'),
                    selector: row => row.mail,
                    sortable: true,
                    filtroHeader: {
                        filterFunction: (item, filtro) => (item.mail && item.mail.toLowerCase().includes(filtro.toLowerCase()))
                    }
                },
                {
                    name: '',
                    selector: row => <NsButtonActionsGroup>
                        <li>
                            <NsButtonAction
                                label={"Rimuovi dal gruppo"}
                                disabled={parseInt(row.is_default) === 1}
                                icona={"fas fa-user-times"}
                                onClick={() => {
                                    onClickEliminaUtentiAssociati(row);
                                }}
                            />
                        </li>
                    </NsButtonActionsGroup>,
                    sortable: false,
                    right: true,
                }
            ]}
        />
    );
}